export const FETCHEDLAYOUT = 'FETCHED_LAYOUT';
export const UPDATEDLAYOUT = 'UPDATED_LAYOUT';
export const RESETLAYOUT = 'RESET_LAYOUT';
export const SETNAVIGATION = 'SET_NAVIGATION';
export const SETAPPLICATIONNAME = 'SET_APPLICATION_NAME';
